import Typography from '../../../styles/typography';

const size = {
  small: Typography.text.sizes.small,
  normal: Typography.text.sizes.normal
};

export { size };
